
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EX_GM_Models"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"capability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cms_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EX_GM_Models"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"capability"},"value":{"kind":"Variable","name":{"kind":"Name","value":"capability"}}},{"kind":"Argument","name":{"kind":"Name","value":"cms_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cms_id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capability"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"effectivePrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportsEndFrame"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"durationMin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"durationMax"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"durationSteps"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apparelOnly"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportsReferences"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qualityOptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qualityDefault"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"resolutionOptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"resolutionDefault"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"resolutionCapOptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"resolutionCapDefault"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":519}};
    doc.loc.source = {"body":"query EX_GM_Models ($capability: String!, $cms_id: Int) {\n    EX_GM_Models (capability: $capability, cms_id: $cms_id) {\n        key\n        capability\n        label\n        description\n        unit\n        effectivePrice\n        supportsEndFrame\n        durationMin\n        durationMax\n        durationSteps\n        apparelOnly\n        supportsReferences\n        qualityOptions\n        qualityDefault\n        resolutionOptions\n        resolutionDefault\n        resolutionCapOptions\n        resolutionCapDefault\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["EX_GM_Models"] = oneQuery(doc, "EX_GM_Models");
        
